module.exports = __webpack_public_path__ + "static/media/share-1.8f662681.png";